<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <!-- <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
      [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2> -->
  <app-lfsa-card-v2 [innTemplate]="enviarTemplateEdit" [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <!-- <ng-template #innTemplateButton>
      <div class="col-md-6 mb-2">
          <div class="pagetitle">
              <div class="btn-group-justified btn-group" style="float: right;">
                  <button (click)="nuevaGarita()" class="btn btn-outline-success">
                      <i aria-hidden="true" class="fa fa-plus"></i>
                      {{DAT_TITULOS.tituloAgregar}}
                  </button>
              </div>
          </div>
      </div>
  </ng-template> -->
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
                     [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
                     [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion"
                     [pagination]="true"
                     [rowData]="rowData">
      [rowSelection]="'single'"
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-md'" [idButton]="'abrirModalNotificaciones'"
                [idClose]="'cerrarModalNotificaciones'"
                [innTemplate]="abrirModalNotificaciones" [titulo]="tituloModal"></app-lfsa-modal>
<ng-template #abrirModalNotificaciones>
  <div class="container-fluid">
    <div class="mb-2">
      ID: <span id="idNotificacion"></span>
    </div>
    <div class="mb-2">
      Descripción: <span id="desca"></span>
    </div>
    <div class="mb-2">
      Motivo: <span id="motivo"></span>
    </div>
    <div class="mb-5">
      Sesión: <span id="sesion"></span>
    </div>
    <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" [loading]="loading" [mostrarBotonVerde]="false"
                                 class="row mt-5"
                                 id="modal-notificaciones">
    </app-lfsa-botones-formulario>
  </div>
</ng-template>
<!-- END MODAL -->
